'use client';

import { useTranslation } from 'next-i18next';
import { MissionControlHireServicesCards } from '@components/features/job-list-content/MissionControlHireServicesCards';
import { CompanyFloatingNavBar } from '@components/features/job-list-content/CompanyFloatingNavBar';

interface MissionControlHireContentProps {
  locale: Locale;
  isAuth: boolean;
  bundlesData?: ApiSchema<'OfferBundle'>[];
}

/**
 * @description Services overview for the Mission Control company (hiring) view.
 */
export const MissionControlHireContent = ({ locale, isAuth, bundlesData }: MissionControlHireContentProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex min-h-full flex-col bg-surface-100">
      <div className="flex grow flex-col items-center justify-center pb-2 pt-6 lg:pt-6">
        <div className="flex w-full max-w-5xl flex-col items-center gap-2 px-4 text-center sm:px-6 lg:px-0">
          <span className="mb-0 w-full text-3xl font-bold leading-snug sm:text-4xl lg:text-[56px] lg:leading-tight">
            {t('hr.hero.title')}
          </span>
          <div className="w-full max-w-4xl px-7">
            <MissionControlHireServicesCards isAuth={isAuth} bundlesData={bundlesData} />
          </div>

          <CompanyFloatingNavBar
            locale={locale}
            selectedButton="services"
            pillBackground="surface-100"
            inline
            isAuthenticated={isAuth}
          />
        </div>
      </div>
    </div>
  );
};
